export const CART_QTY_EXCEEDS_SALES_ERROR_KEY = "feature.salesCampaign.cart.quantityError";
